"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var antd_1 = require("antd");
var oidc_1 = __importDefault(require("../../../..//pages/oidc"));
var logout_1 = __importDefault(require("../../../../pages/oidc/logout"));
var env_1 = require("App/util/env");
var reactUserMenuEnv = process.env.REACT_APP_EDIT_USER_PROFILE_URL;
var userMenuEnv = env_1.getEnv({
    EDIT_USER_PROFILE_URL: reactUserMenuEnv !== undefined
        ? reactUserMenuEnv
        : 'http://home.dev.cloud.accallio.com/profile/',
});
var ProfileMenu = function () {
    var history = react_router_dom_1.useHistory();
    var handleLogout = function (clickParam) {
        history.push("" + oidc_1.default.routeProps.path + logout_1.default.routeProps.path);
    };
    var handleProfileClick = function () {
        if (userMenuEnv.EDIT_USER_PROFILE_URL.startsWith('http')) {
            window.open(userMenuEnv.EDIT_USER_PROFILE_URL, '_blank');
        }
        else {
            history.push(userMenuEnv.EDIT_USER_PROFILE_URL);
        }
    };
    var menu = (react_1.default.createElement(antd_1.Menu, { selectable: false },
        react_1.default.createElement(antd_1.Menu.Item, { onClick: handleProfileClick },
            react_1.default.createElement(antd_1.Icon, { type: "control" }),
            "Edit Profile"),
        react_1.default.createElement(antd_1.Menu.Item, { onClick: handleLogout },
            react_1.default.createElement(antd_1.Icon, { type: "logout" }),
            "Logout")));
    return (react_1.default.createElement(antd_1.Dropdown, { className: "dropdown-btn", overlay: menu, placement: "bottomRight", trigger: ['click'] },
        react_1.default.createElement(antd_1.Icon, { type: "user" })));
};
exports.default = ProfileMenu;
//# sourceMappingURL=index.js.map